/**
 * ACF 6.0 block - js entrypoint
 *
 * entry point for webpack, can import js scripts and create css files for block
 * @package hum-fse-6-blocks
 */

import "./scss/_curtains.scss";
import anime from 'animejs/lib/anime.es.js';

document.addEventListener( 'DOMContentLoaded', function () {

  window.scrollTo({ top: 0, behavior: 'smooth' });

  const bezierCurve = "cubicBezier(.78,.03,.34,.87)"; //"cubic-bezier(.91,0,.84,.33)";// "cubic-bezier(.53,.09,.93,.55)"; //"cubic-bezier(.85,0,.9,.67)";
  
  const canvasSlideOne = document.querySelector( '.curtain--1' );
  if ( canvasSlideOne ) {
    const slideOneHeight = canvasSlideOne.getBoundingClientRect().height;

    anime({
      targets: canvasSlideOne,
      duration: 800,
      delay: 1000,
      translateY: [0, -slideOneHeight],
      easing: bezierCurve,
    });
  }

  const canvasSlideTwo = document.querySelector( '.curtain--2' );
  if ( canvasSlideTwo ) {

    const slideTwoHeight = canvasSlideTwo.getBoundingClientRect().height;

    anime({
      targets: canvasSlideTwo,
      duration: 820,
      delay: 1100,
      translateY: [0, -slideTwoHeight],
      easing: bezierCurve,
    });
  }

  const siteLogo = document.querySelector( '.acf-block-curtains .curtain__site-logo' );
  if ( siteLogo ) {

    const siteLogoCircles = siteLogo.querySelector( '.hum-logo-circle-group' )
    
    anime({
      targets: siteLogoCircles,
      duration: 400,
      delay: 0,
      rotate: [0, 180],
      easing: bezierCurve,
      transformOrigin: 'center',
    });
  }

  const pageContent = document.querySelector( '.page-template-page-animated .wp-site-blocks > main');
  if ( pageContent ) {

    anime({
      targets: pageContent,
      duration: 400,
      delay: 1200,
      translateY: [200, 0],
      easing: bezierCurve,
    });
    
    anime({
      targets: pageContent,
      duration: 600,
      delay: 1100,
      opacity: [0, 1],
      easing: bezierCurve,
    });
  }
  
});